import { SkeletonLoader } from '@/components/SkeletonLoader';

export default function MeetingRoomSearchFiltersSkeleton() {
  return (
    <div className="md:flex md:justify-between items-center self-stretch md:flex-row-reverse gap-6">
      <SkeletonLoader className="w-full md:w-60 h-10 rounded-lg mb-5 md:mb-0" />
      <div className="flex gap-5">
        <SkeletonLoader className="w-40 h-10 rounded-full" />
        <SkeletonLoader className="w-32 h-10 rounded-full" />
        <SkeletonLoader className="w-32 h-10 rounded-full" />
      </div>
    </div>
  );
}
